<template>
    <div class="border border-white px-8 inline-flex items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-gray-300 select-none">
        <div class="group relative flex items-center justify-center hover:scale-125 transition h-fit hover:cursor-pointer">
            <img :src="event.cover.cached_url" :alt="event.name" class="rounded min-h-[120px] object-cover object-center" />
            <div class="h-full w-full p-2 md:p-1 2xl:p-2 flex flex-col justify-between absolute bottom-0 left-0 right-0 top-0 rounded-md bg-black bg-opacity-30 text-white opacity-0 group-hover:opacity-100 transition-opacity">
                <div class="flex justify-between items-center gap-4">
                    <span v-if="event.types[0]" class="border border-white rounded bg-transparent px-[2px] py-[1px] text-[0.35rem]">{{event.types[0].name}}</span>
                    <div v-else></div>
                </div>
                <h2 class="font-vectrex text-sm md:text-xs 2xl:text-sm line-clamp-3">{{event.name}}</h2>
                <span class="text-[0.35rem]">{{ formatDate(event.finishing_date) }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import AtomIconButton from "../../global/atoms/AtomIconButton.vue";
import AtomLabel from "../../global/atoms/AtomLabel.vue";
import {formatDate} from "../../../utils/formatDate";

export default {
    name: "OrganismImageHover",
    components: {AtomLabel, AtomIconButton},
    props: {
        event: {
            type: Object,
            required: true
        },
        isVisible:{
            type: Boolean,
            default: true
        }
    },
    methods: {formatDate},
}
</script>

<style scoped>

.transition-width-height {
    transition: width 0.5s ease-in-out, height 0.5s ease-in-out;
}

</style>
